import { render } from "./ReceiptModal.vue?vue&type=template&id=4ee4f25f&scoped=true"
import script from "./ReceiptModal.vue?vue&type=script&lang=js"
export * from "./ReceiptModal.vue?vue&type=script&lang=js"

import "./ReceiptModal.vue?vue&type=style&index=0&id=4ee4f25f&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee4f25f"]])

export default __exports__